export default __webpack_public_path__ + "static/media/icon-hamburger.8d873e89.svg";